module.exports = __webpack_public_path__ + "img/Truppführer_ESS.107f4460.svg";